/* eslint-disable camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { ShipmentOperation } from '@/api/operations/models/shipment-operation'

@Component
export class ShipmentOperationGuardMixin extends Vue {
    $_canCreateShipmentRequest(): boolean {
        return this.$_hasOperationInCurrentLaboratory(ShipmentOperation.CREATE)
    }
}
